import { EID_REPORT } from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeEIDReport } from "lib/serializers/eidReport";

const baseReducer = apiModelOfflineFetchReducer(EID_REPORT, {
  deserializer: deserializeEIDReport,
  clearOnRequest: false,
});

export default baseReducer;
